export default __webpack_public_path__ + "34476cb84331109867b3453927d64a4e.png";